// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PoundOutlinedSvg from "@fishx/icons-svg/es/asn/PoundOutlined";
import FishxIcon from '../components/FishxIcon';

var PoundOutlined = function PoundOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PoundOutlinedSvg
  }));
};

PoundOutlined.displayName = 'PoundOutlined';
export default React.forwardRef(PoundOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PoundOutlined.js
// module id = 3840
// module chunks = 0